import { createApp, ComponentPublicInstance } from "vue";
import Modal, { ModalOptions } from "@/components/Modal/Modal.vue";

// 定义 Modal 组件的实例类型
interface ModalInstance extends ComponentPublicInstance {
  showModal: (options: ModalOptions) => void;
  hideModal: () => void;
}
class ModalService {
  private instance: ModalInstance | null;

  constructor() {
    this.initialize();
  }

  initialize() {
    const modalDiv = document.createElement("div");
    document.body.appendChild(modalDiv);

    const modalApp = createApp(Modal);
    this.instance = modalApp.mount(modalDiv) as ModalInstance;
  }

  showModal(options: ModalOptions) {
    return this.instance.showModal(options);
  }

  hideModal() {
    return this.instance.hideModal();
  }
}

// 创建单例
export const modalService = new ModalService();

// 定义 Vue 插件
export default {
  install: (app) => {
    // 添加全局方法
    app.config.globalProperties.$showModal = (options) => modalService.showModal(options);
    app.config.globalProperties.$hideModal = () => modalService.hideModal();

    // 同时提供依赖注入方式
    app.provide("$modal", {
      showModal: (options) => modalService.showModal(options),
      hideModal: () => modalService.hideModal(),
    });
  },
};
